import store from '@/store';
import { NavigationGuardNext, Route } from 'vue-router';
import { RouteName } from '@/router/types';

export function dashboardGuard(to: Route, from: Route, next: NavigationGuardNext): boolean {
  if (!store.getters['tenant/isDashboardAvailable']) {
    next({ name: RouteName.Community });
  } else {
    next();
  }
  return true;
}
